<template>
    <div>
        <div class="header_unit header_bg_blue">
            <div class="header_box">
                <div class="menu_center">
                    <p class="menu_center_tex_s">コメント履歴</p>
                    <p class="menu_center_tex_l">{{year}}年{{month}}月</p>
                </div>
            </div>
        </div>
        <div class="main_unit">
            <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
            <div class="comment_tbl_unit wd976 tbl_ht_none tbl_bg_blue" v-show="!isInitLoading">
                <table>
                    <tbody>
                        <tr>
                            <th class="wd140 checkSetting_text_align">氏名</th>
                            <th class="wd70 checkSetting_text_align">登録時刻</th>
                            <th class="wd720 checkSetting_text_align ">改善措置／コメント</th>
                            <th class="wd70 checkSetting_text_align">コメント対象日</th>
                        </tr>
                        <tr v-for="CheckComment in reportMonthlyComments" :key="CheckComment.dailyCheckCommentId">
                            <td class="wd140 tbl_tex_left text_white_space">{{managerType()}}</td>
                            <td class="wd70">{{CheckComment.createdDatetime}}</td>
                            <td class="tbl_tex_left wd720 text_white_space">
                                <p class="tbl_comment">{{CheckComment.comment}}</p>
                            </td>
                            <td class="70">{{CheckComment.checkDate}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

    import PulseLoader from '@/app/components/PulseLoader.vue'

    export default {
        name: 'MonthlyCheckReportHistory',
        components: {
            PulseLoader
        },
        props:{
            date: {
                type: Date,
                required: true,
            },
            year: Number,
            month: Number,
            day: Number,
            manager: Number,
        },
        data: function () {
            return {
                isInitLoading:true,
                reportMonthlyComments: [
                    {
                        "reportCommentId": null,
                        "checkDate": "",
                        "createdDatetime": "",
                        "comment": "",
                    }
                ],
                managerName: "",
            }
        },
        computed:{
            brandPath: function () {
                return this.$route.params.brandPath
            },
        },
        created: function(){
            this.calc();
        },
        methods: {
            calc() {

                this.isInitLoading = true;

                var brandId = this.$store.getters['brand/id'];
                var storeId = this.$store.getters['store/data'].store_id;
                var url = this.$apiEndpoint + 'manage/brand/' + brandId + '/store/' + storeId + '/comment_history/' + this.year + '/' + this.month + '/' + this.day + '/' + this.manager;

                this.$axios
                    .get(url)
                    .then(response => (
                        this.reportMonthlyComments = response.data.reportMonthlyComments))
                    .catch(err => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    if (err.customError.code == 401) {
                        //店舗管理者のtokenエラーの場合
                        this.$cookies.set('user-api-token', '', 0)
                        this.$store.dispatch('store/doClear')
                    }
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isInitLoading = false)
            },
            managerType: function () {
                if (this.manager === 1) {
                    return this.managerName = "店舗管理者";
                } else if (this.manager === 2) {
                    return this.managerName = "企業管理者";
                } else if (this.manager === 3) {
                    return this.managerName = "その他管理者";
                }
            }
        }
    }
</script>
